import React from "react";

// Official Not By Will broken-chain mark — the exact photograph supplied by the founder.
// Do not substitute or generate alternate logo art.
export const Logo = ({ className = "w-9 h-9" }) => (
  <img
    src="/nbw-logo.png"
    alt="Not By Will"
    draggable="false"
    className={`${className} object-contain select-none`}
  />
);

// Full lockup: mark + wordmark + optional tagline.
export const LogoLockup = ({ markClassName = "w-11 h-9", tagline = false, className = "" }) => (
  <span className={`flex items-center gap-2.5 ${className}`}>
    <Logo className={markClassName} />
    <span className="text-left leading-none">
      <span className="block font-heading font-extrabold tracking-[0.14em] text-brand-navy text-lg">NOT BY WILL</span>
      {tagline && (
        <span className="block text-[10px] tracking-[0.12em] uppercase text-brand-teal-dark mt-1">By His strength. And our faith.</span>
      )}
    </span>
  </span>
);

export default Logo;
